/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface ZocdocProviderResult {
  provider_location_id: string;
  provider_id?: string | null;
  full_name?: string | null;
  specialties?: string[];
  address?: string | null;
  city?: string | null;
  state?: string | null;
  distance_to_patient_mi?: number | null;
  first_availability_date?: string | null;
  provider_photo_url?: string | null;
  accepts_patient_insurance?: string | null;
  gender_identity?: string | null;
  statement?: string | null;
}
